/**
 * Load all PMW functions
 *
 * Ignore event listeners. They need to be loaded after
 * we made sure that jQuery has been loaded.
 */

require("./functions")

/**
 * Load consent management module as a chunk
 * @returns {Promise<void>}
 */
window.wpm.loadConsentModule = async () => {
	const consentModule = await import(/* webpackChunkName: "consent-management" */ "./consent/consent.mjs")
	window.wpm.consent = consentModule
	
	const apiModule = await import(/* webpackChunkName: "consent-api" */ "./consent/api.mjs")
	window.pmw = window.pmw || {}
	window.pmw.consent = window.pmw.consent || {}
	window.pmw.consent.api = apiModule
	
	return consentModule
}

window.pmw = window.pmw || {
	console: require("./console.mjs"),
}

require("./ip_services")

// #if process.env.TIER === 'premium'
// if (wpm.canLoadPremiumFeatures()) {
// 	require("./functions_premium")
// }
// #endif
